import { render, staticRenderFns } from "./SupplierKYCFormStep.vue?vue&type=template&id=3f1ee50e&scoped=true&"
import script from "./SupplierKYCFormStep.vue?vue&type=script&lang=js&"
export * from "./SupplierKYCFormStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1ee50e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f1ee50e')) {
      api.createRecord('3f1ee50e', component.options)
    } else {
      api.reload('3f1ee50e', component.options)
    }
    module.hot.accept("./SupplierKYCFormStep.vue?vue&type=template&id=3f1ee50e&scoped=true&", function () {
      api.rerender('3f1ee50e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/requests/detailPages/supplierDetailPages/SupplierKYCFormStep.vue"
export default component.exports